import {Component, OnInit} from '@angular/core';
import {PrimeNGConfig} from 'primeng/api';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {environment} from '../environments/environment';
import {CredentialsService} from './@shared/services/credentials.service';
import {ImUserService} from './@shared/services/im-user.service';
import {ApplicationAnalyticsService} from './application-analytics/application-analytics.service';
import {ApplicationLogVoModel} from './application-analytics/application-log-vo.model';
import {Title} from '@angular/platform-browser';


// tslint:disable-next-line:ban-types
declare const gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    topbarTheme: string = 'blue';

    menuTheme: string = 'light';

    layoutMode: string = 'light';

    menuMode: string = 'static';

    inlineMenuPosition: string = 'bottom';

    inputStyle: string = 'filled';

    ripple: boolean = true;

    isRTL: boolean = false;

    constructor(private primengConfig: PrimeNGConfig, private router: Router, private credentialsService: CredentialsService, private imUserService: ImUserService,
                private appAnalyticsService: ApplicationAnalyticsService, private activatedRoute: ActivatedRoute, private titleService: Title) {

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => {
                let child = this.activatedRoute.firstChild;
                while (child) {
                    if (child.firstChild) {
                        child = child.firstChild;
                    } else if (child.snapshot.data && child.snapshot.data['title']) {
                        return child.snapshot.data['title'];
                    } else {
                        return null;
                    }
                }
                return null;
            })
        ).subscribe((data: any) => {
            if (data) {
                this.titleService.setTitle(data);
            } else {
                this.titleService.setTitle('Freight Platform');
            }
        });
        this.addGAScript();

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
                const loggedInUser = localStorage.getItem('logged-in-user');
                const userLocation = localStorage.getItem('userLocation') ? JSON.parse(localStorage.getItem('userLocation')) : null;
                const user = JSON.parse(loggedInUser);
                if (event?.url !== '/web-analytics' && environment?.env !== 'dev' && user?.username !== 'atik@mslc.in') {
                    // user?.username !== 'atik@mslc.in'
                    const logVO: ApplicationLogVoModel = {
                        pageView: event?.urlAfterRedirects,
                        userAction: 'GENERAL',
                        pageTitle: document.title,
                        environment: environment.env,
                        regionName: userLocation?.regionName,
                        countryCode: userLocation?.countryCode
                    };
                    if (loggedInUser) {
                        this.appAnalyticsService.logAnalytics(logVO);
                    }
                }

            }
        )
        ;


    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        console.log('Active Environment : ', environment.env);
    }

    addGAScript() {
        const gtagScript: HTMLScriptElement = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.gaTrackingId;
        document.head.prepend(gtagScript);
        // /** Disable automatic page view hit to fix duplicate page view count  **/
        gtag('config', environment.gaTrackingId, {send_page_view: false});
    }
}
